import { Outlet } from '@remix-run/react'
import MainLayout from '#app/shared/ui/layout/MainLayout.js'

export default function Index() {
  // TODO: defer topBrands and place MainLayout in a place that user and guest can use at same time, so no remake the component and request when changing from guest pages to user

  return (
    <MainLayout className="font-saira">
      <Outlet />
    </MainLayout>
  )
}
